// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"290":"Infrastructure","539":"Blog"}[chunkId] + "." + {"290":"529e1388","539":"cd0c3f2f"}[chunkId] + ".chunk.css";
};